export enum actionTypes {
    GAMES_FAVORITES_SET = 'GAMES_FAVORITES:SET',
    GAMES_CONFIGURATION_EXCLUDED_GAME_CODES_SET = 'GAMES_CONFIGURATION:EXCLUDED_GAME_CODES:SET',
    GAMES_FAVORITES_TOGGLE = 'GAMES_FAVORITES:TOGGLE',
    GAMES_CONFIGURATION_UPDATE = 'GAMES_CONFIGURATION:UPDATE',
    GAMES_CONFIGURATION_GAMES_FEED_ADD = 'GAMES_CONFIGURATION:GAMES_FEED:ADD'
}
